export class LoginMessaging {
  static readonly type = '[Messaging] Login';
}
export class ClearMessagingDetails {
  static readonly type = '[Messaging] Clear Details';
}
